module.exports = __webpack_public_path__ + "img/header-bg.3e545ea1.png";